import { render, staticRenderFns } from "./studentForm.vue?vue&type=template&id=3a2e5eb6&scoped=true"
import script from "./studentForm.vue?vue&type=script&lang=js"
export * from "./studentForm.vue?vue&type=script&lang=js"
import style0 from "./studentForm.vue?vue&type=style&index=0&id=3a2e5eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2e5eb6",
  null
  
)

export default component.exports